module.exports = __webpack_public_path__ + "img/thirdqr.3dba0f3a.png";